import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import 'antd/dist/antd.css'
import './home.less'
import Subapp from '../subapp'
import { registerMicroApps, start, initGlobalState, runAfterFirstMounted } from 'qiankun'
import './index.less'
import DefaultLayout from '@/components/layout/default'
import { getQueryPrams } from '@/utils/tools'
import { excludeAssetWhiteList, getSubAppConfig } from './qiankun.config'

declare let window: any

class AdminHome extends Component<any, any> {
  constructor (props: unknown) {
    super(props)
    this.state = {
      loading: false,
      subLoader: null
    }
  }

  componentDidMount (): void {
    this.sojInit()
    const loader = (loading: any) => {
      const container = document.getElementById('subapp-container')
      ReactDOM.render(<Subapp loading={loading} />, container)
    }
    this.setState({
      loading: true,
      subLoader: loader
    })
    const subappConfig: any[] = getSubAppConfig(loader)
    registerMicroApps(
      subappConfig,
      {
        beforeLoad: [
          (app: any) =>
            new Promise((resolve) => {
              console.log('[LifeCycle] before load %c%s', 'color: green;', app.name)
              resolve(app.name)
            })
        ],
        beforeMount: [
          (app: any) =>
            new Promise((resolve) => {
              console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name)
              resolve(app.name)
            })
        ],
        afterUnmount: [
          // @ts-ignore
          (app) => {
            console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
          }
        ]
      }
    )
    const { setGlobalState } = initGlobalState({
      user: 'qiankun'
    })

    setGlobalState({
      appName: 'OpenCMS',
      ignore: 'master'
    })

    /**
         * Step4 启动应用
         */
    start({
      prefetch: false,
      excludeAssetFilter: (assetUrl: string): any => {
        // excludeAssetFilter 参数来放行这部分资源请求
        const whiteList: string[] = excludeAssetWhiteList
        const res: string | undefined = whiteList.find((item) => assetUrl.includes(item))
        return !!res
      }
    })
    runAfterFirstMounted(() => {
      console.log('[MainApp] first app mounted')
    })
  }

  sojInit = (): void => {
    const logger = new window.LoggerSDK.Logger({
      sojParams: {
        plat: 1,
        site: 'anjuke'
      }
    })
    // eslint-disable-next-line no-prototype-builtins
    if (!window.hasOwnProperty('logger')) {
      window.logger = logger.getLogger()
    }
  };

  render (): JSX.Element {
    const query = getQueryPrams()
    const renderBreadcrumb = query.breadcrumb !== '0'
    const footerRender = query.footerRender !== '0'
    const menuRender = query.menuRender !== '0'
    const headerRender = query.headerRender !== '0'
    const immersionRender = query.immersion === '1'
    console.warn('render home:', query)
    let props: any = {
      showBreadcrumb: renderBreadcrumb,
      footerRender,
      menuRender,
      headerRender
    }
    if (immersionRender) {
      props = {
        showBreadcrumb: false,
        footerRender: false,
        menuRender: false,
        headerRender: false
      }
    }
    return (
      <DefaultLayout {...props}>
          <div id="subapp-container" className="view" style={{ flex: 1 }}></div>
      </DefaultLayout>
    )
  }
}

export default AdminHome
